import "./App.css";
import { useState } from "react";
import SelectOption from "./components/SelectOption";
import DisplayProgressions from "./components/DisplayProgressions";
import PresetProgressionsPage from "./components/PresetProgressionsPage";

function App() {
  const [chords, setChords] = useState([]);
  const [pagina, setPagina] = useState("principal");

  return (
    <div className="container mx-auto px-4 py-6">
      <div className="bg-purple-900 rounded-lg overflow-hidden">
        <div className="flex flex-col gap-4 p-6 md:flex-row md:items-center md:justify-between">
          <h1 className="font-black text-white text-3xl text-center md:text-left">
            Gerar Progressão Harmônica para Piano
          </h1>
          <div className="flex gap-3 justify-center md:justify-end">
            <button
              className={`px-4 py-2 rounded font-semibold ${
                pagina === "principal" ? "bg-white text-purple-900" : "bg-purple-700 text-white"
              }`}
              onClick={() => setPagina("principal")}
              type="button"
            >
              Página principal
            </button>
            <button
              className={`px-4 py-2 rounded font-semibold ${
                pagina === "prontas" ? "bg-white text-purple-900" : "bg-purple-700 text-white"
              }`}
              onClick={() => setPagina("prontas")}
              type="button"
            >
              Progressões prontas
            </button>
          </div>
        </div>
      </div>

      <div className="mt-6">
        {pagina === "principal" ? (
          <div className="flex flex-col gap-6 md:flex-row">
            <SelectOption chordsApp={chords} setChordsApp={setChords} />
            <DisplayProgressions chordsApp={chords} />
          </div>
        ) : (
          <PresetProgressionsPage />
        )}
      </div>
    </div>
  );
}

export default App;
